import { render, staticRenderFns } from "./vpd-welcome-text.vue?vue&type=template&id=6af1a7f8"
import script from "./vpd-welcome-text.vue?vue&type=script&lang=js"
export * from "./vpd-welcome-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports